<template>
  <div>
      <!-- editor -->
      <web-editor
      class="hidden-sm-and-down"
      :docCreate="docCreate"
      :initial="dataItem"
      @data="save"
    ></web-editor>

    <mobile-editor
      class="hidden-md-and-up"
      :docCreate="docCreate"
      :initial="dataItem"
      @data="save"
    ></mobile-editor>
    <!-- end -->
  </div>
</template>

<script>
import MobileEditor from "../_components/mobile-editor.vue";
import WebEditor from "../_components/web-editor.vue";
export default {
  components: {
    WebEditor,
    MobileEditor
  },
  data: () => ({
    dataItem: {},
    docCreate: true,
  }),
  methods: {
    save(data) {
      const url = "/documents";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$router.push("/sales/order");
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
};
</script>